import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const About = () => {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate('/about');
    window.scrollTo(0, 0);
  };

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative order-2 md:order-1">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/3194521/pexels-photo-3194521.jpeg"
                alt="Upscale Team"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-2xl opacity-30"></div>
          </div>

          {/* Content */}
          <div className="space-y-6 order-1 md:order-2">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
              About <span className="text-blue-600">us</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Emerging from the dynamic Norwegian startup studio Ymir in 2023, Upscale embodies the culmination of extensive experience gained through the development and expansion of startups across Norway, India, and the UK.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Established by Arjun Bhatt, a seasoned growth hacker, Upscale is dedicated to assisting startups in overcoming distinctive growth hurdles, particularly in the areas of acquiring and engaging early adopters.
            </p>
            <Button
              onClick={handleReadMore}
              className="bg-blue-600 hover:bg-blue-700 text-white group"
              size="lg"
            >
              Read More
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;